import type React from 'react';
import {IconButton, Tooltip} from '@mui/material';
import {DeleteOutline, EditOutlined} from '@mui/icons-material';

type Props = {
    kind: 'edit' | 'delete';
    /** What it acts on, for the tooltip and screen readers, e.g. "requirement ISO 14001". */
    label: string;
    onClick: () => void;
};

/** Edit / delete as icon buttons on a row (Mithra 3.0); delete is red. */
export const RowAction: React.FC<Props> = ({kind, label, onClick}) => {
    const title = `${kind === 'edit' ? 'Edit' : 'Remove'} ${label}`;
    return (
        <Tooltip title={title}>
            <IconButton size="small" aria-label={title} onClick={onClick} color={kind === 'delete' ? 'error' : 'default'}>
                {kind === 'edit' ? <EditOutlined fontSize="small"/> : <DeleteOutline fontSize="small"/>}
            </IconButton>
        </Tooltip>
    );
};
